export const STORAGE_KEYS = { SESSION: "jogunbiz.session" };

// 회원 역할
export const ROLES = { HQ: 'hq', PARTNER: 'partner', GENERAL: 'general' };
export const ROLE_LABELS = { hq: '본사직원', partner: '파트너', general: '일반' };

export const APP_CONFIG = {
  social: { googleWebClientId: "", kakaoNativeKey: "" },
  sms: { cfUrl: "https://asia-northeast3-jogunbiz.cloudfunctions.net/sendSms", label: "조군산업" },
  testRange: { start: "01062141000", end: "01062149755" },
  kakaoCustomTokenUrl: "https://asia-northeast3-jogunbiz.cloudfunctions.net/kakaoCustomToken",
  appleCustomTokenUrl: "https://asia-northeast3-jogunbiz.cloudfunctions.net/appleCustomToken",
  resetPasswordUrl: "https://asia-northeast3-jogunbiz.cloudfunctions.net/resetPassword",
};

// 렉스크리트 제품 카테고리 (대분류 > 소분류)
export const PRODUCT_CATEGORIES = {
  '프라이머': [
    '(흡수,비흡수면겸용)슈퍼그립 프라이머',
    '(흡수면 전용)스탠다드 프라이머',
  ],
  '마이크로시멘트(본품)': [
    '1액형 마이크로 플렉스',
    '2액형 드럭 (거친입자)',
    '2액형 베이스 (중간입자)',
    '2액형 미디엄 (고운입자)',
  ],
  '조색 안료(Color)': [
    '프리미엄 수입 안료',
  ],
  '코팅제': [
    '코팅 씰러(표면 보호제)',
    '(무광)아쿠아맥스 코팅제',
    '(무광)아쿠아 바니쉬 고성능 코팅제',
  ],
  '균열(크랙) 보수 제품': [],
  '테라폭시': [],
  '수평몰탈': [],
  '시공 도구 & 부자재': [
    '롤러',
    '보강 탄성 메쉬',
    '수지고대',
    '헤라',
  ],
  '기타': [],
};

// '기타' 선택 시 분류명을 직접 입력해서 등록할 수 있음
export const ETC_CATEGORY = '기타';

// 렉스크리트 제품 목록 (레거시 - 주문페이지 호환용, 추후 Firestore 전환)
export const PRODUCTS = [];

// 주문 상태
export const ORDER_STATUS = {
  requested: { label: "주문요청", color: "#FF9800" },
  quoted: { label: "견적수신", color: "#42A5F5" },
  requoted: { label: "견적재수신", color: "#FB8C00" },
  confirmed: { label: "입금확인중", color: "#26A69A" },
  preparing: { label: "배송준비중", color: "#7B1FA2" },
  shipped: { label: "배송중", color: "#5C6BC0" },
  completed: { label: "배송완료", color: "#66BB6A" },
  cancelled: { label: "취소", color: "#EF5350" },
};
